<template>
  <form class="bg-dark text-white rounded position-relative"
        :action="action"
        :class="{ 'mobile-light' : mobileLight}"
        @submit="emitSubmit"
  >
    <b-row class="pt-3 py-md-3 px-3 px-md-4 align-items-center">
      <div class="col-12" :class="{'col-12 col-xl-auto mb-xl-0' : !isTroubleshootingSearch}">
        <h2 v-show="message"
            class="text-center text-sm-left"
            :class="{ 'd-xl-none' : isOpened}"
        >
          {{ message }}
        </h2>
      </div>
      <div :class="[isOpened ? 'col-12' : 'col']">
        <ErrorInput class="border-dark-sm rounded"
                    :submit-on-close="submitOnClose"
                    :initial-keyword="initialKeyword"
                    :ajax="ajax"
                    :placeholder="placeholder"
                    :search-label="translatedLabel('searchButton', 'CommonFunctional')"
                    :empty-label="translatedLabel('emptySearchButton', 'CommonFunctional')"
                    @change="isOpen"
                    @submit="submitForm"
        />
      </div>
      <div v-if="isTroubleshootingSearch && !isOpened" class="col-12 col-sm-auto mt-2 mt-sm-0">
        <div class="bg-gray-100 p-1 rounded">
          <b-form-radio-group
            v-model="selected"
            class="btn-troubleshooting-switch w-100"
            :options="translatedOptions"
            buttons
            @change="handleSwitchChange"
          />
        </div>
      </div>
    </b-row>
    <input ref="submitBtn" type="submit" class="d-none">
    <div v-if="disabled" class="mask disabled rounded" />
  </form>
</template>

<script>
import ErrorInput from '@/components/common/ErrorInput'

export default {
  conceptName: ['CommonFunctional', 'TroubleshootingProcedures'],
  components: {
    ErrorInput
  },
  props: {
    action: {
      type: String,
      required: false
    },
    message: {
      type: String,
      required: false
    },
    initialKeyword: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    },
    ajax: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    submitOnClose: {
      type: Boolean,
      required: false,
      default: true
    },
    mobileLight: {
      type: Boolean,
      required: false,
      default: false
    },
    isTroubleshootingSearch: {
      type: Boolean,
      required: false,
      default: false
    },
    initialSearchType: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      isOpened: false,
      value: this.initialKeyword,
      selected: this.initialSearchType
    }
  },
  computed: {
    translatedOptions() {
      return [
        {text: this.translatedLabel('exactMatches', 'TroubleshootingProcedures'), value: 'true'},
        {text: this.translatedLabel('partialMatches', 'TroubleshootingProcedures'), value: 'false'}
      ]
    }
  },
  methods: {
    isOpen(s) {
      this.isOpened = s
    },
    emitSubmit(e) {
      this.$emit('search', this.value, this.selected)
      if (this.ajax && e) e.preventDefault()
    },
    submitForm(k) {
      this.value = k
      this.updateUrlParam('keyword', k)
      this.$refs['submitBtn'].click()
    },
    handleSwitchChange(s) {
      this.updateUrlParam('searchType', s)
      setTimeout(() => {
        this.emitSubmit()
      }, 500)
    }
  }
}
</script>

<style lang="scss">
@import '../../scss/_colors';
@import '../../scss/grid';

.btn-troubleshooting-switch {
  label {
    background: $gray-100;
    color: $gray-800;
    font-weight: bold;
    border-color: transparent;
    cursor: pointer;

    &:hover {
      opacity: .8;
      background: transparent !important;
      border-color: transparent !important;
      color: $gray-800 !important;
    }

    &.active {
      border-color: transparent !important;
      background: $white !important;
      color: $black !important;
      box-shadow: 0 .15rem .5rem rgba($black, .35);
      border-radius: 0.125rem !important;
    }
  }
}

.mobile-light {
  @include media-breakpoint-down('sm') {
    background: $white !important;
    color: $black !important;

    .border-dark-sm {
      border: 1px solid $gray-400;
    }
  }
}
</style>
